import React, { useEffect } from 'react'

import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'

import Logo from './../../../assets/img/ares-logo.png'
import FlatProjectImage from './../../../assets/img/flat-project-image.jpg'


import './index.css'

export default function Header() {

    useEffect(() => {
        console.log('header iniciou')
    }, [])

    return (
        <section className="Header">
            <Navbar expand="lg">
                <Navbar.Brand href="#home">
                    <img src={Logo} alt="Logo"/>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ml-auto">
                        <Nav.Link href="#about">Sobre</Nav.Link>
                        <Nav.Link href="#features">Funcionalidades</Nav.Link>
                        <Nav.Link href="#plan">Preços</Nav.Link>
                        <Nav.Link href="#faq">Faq</Nav.Link>
                        <Nav.Link href="#contact">Contato</Nav.Link>
{/* 
                        <a className="btn btn-default" href="/localizator">
                            Localizador
                        </a> */}

                        <a className="btn btn-primary" href="/login">
                            Entrar
                        </a>

                        {/* <a className="btn btn-secondary" href="/register">
                            Cadastrar-se
                        </a> */}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>

            <div className="body">
                    <div className="content">
                        <div className="left">
                            <h1>Monitoramento fácil e rápido!</h1>
                            <h2>Monitore sua empresa, cargas ou sua casa com a gente</h2>

                            <p>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                            </p>


                            <Button variant="primary">
                                Começar agora
                            </Button>
                        </div>

                        <div className="right">
                            <img src={FlatProjectImage} alt="Project image"/>
                        </div>
                    </div>
            </div>
        </section>
    )
}